import { render, staticRenderFns } from "./ScholarshipsTable.vue?vue&type=template&id=3d4759d2&scoped=true&"
import script from "./ScholarshipsTable.vue?vue&type=script&lang=js&"
export * from "./ScholarshipsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4759d2",
  null
  
)

export default component.exports